import { render, staticRenderFns } from "./Therapist.vue?vue&type=template&id=47e5ac3d&"
import script from "./Therapist.vue?vue&type=script&lang=js&"
export * from "./Therapist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports